import fetchMerchandiseSellers from 'actions/merchandise/fetchMerchandiseSellers'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

type ReturnType = [App.MerchandiseOfferSeller | undefined, boolean, any]

function useMerchandiseSeller(id: string | undefined): ReturnType {
  const dispatch = useAppDispatch()
  const sellersState = useAppSelector(state => state.merchandise.merchandiseSellers)

  useEffect(() => {
    if (id) {
      dispatch(fetchMerchandiseSellers([id]))
    }
  }, [dispatch, id])

  if (!id) {
    return [undefined, false, undefined]
  }

  return [
    sellersState.sellers[id],
    sellersState.fetching[id] ?? false,
    sellersState.errors[id],
  ]
}

export default useMerchandiseSeller
